// Copyright 2018 The MathWorks, Inc.

/**
 * The list of status bar components that support actions
 */

define([
        "./TypeConstants"
    ],
    function (TypeConstants) {
        return [
            TypeConstants.STATUS_PUSH_BUTTON,
            TypeConstants.STATUS_TOGGLE_BUTTON
        ];
    });